import Vue from 'vue'
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import global from '@/global.js';
import store from '@/store';
import http from '@/common/ajax.js'
dayjs.locale("zh-cn");

/**
 * 格式化日期
 */
Vue.prototype.$dayjs = dayjs;

function dateformat(value, format = 'YYYY-MM-DD') {
    if (!value) {
        return '-';
    }
    if (value == '-') {
        return '-'
    }
    return dayjs(value).format(format);
}
Vue.prototype.$dateformat = dateformat
Vue.filter('datetime', dateformat);

Vue.filter('enumer', function (value, type) {

    if (!global[type] || !global[type] instanceof Array) {
        return ''
    }
    let item = global[type].find(r => r.value == value);
    if (!item) {
        return '-'
    }
    return item.text
})

Vue.filter('gang', function (value, def = "-") {
    if (!value) {
        return def
    } else {
        return value
    }
})


Vue.filter('CodeName', function (value, type, def = "-") {
    if (!value || !type) {
        return def;
    } else {
        let item = store.getters
            .getInternalCodeByCodeType(type)
            .find((r) => r.CodeID == value).CodeName;
        if (!item) {
            return def;
        }
        return item;
    }
})
Vue.filter('UserNameInfo', function (value, def = "-") {
    if (!value) {
        return def;
    } else {
        let item = store.state.UserNameInfo.find(
            (r) => r.UId == value
        )?.Username;
        if (!item) {
            return def;
        }
        return item;
    }
})